import { Injectable, Inject } from '@angular/core';

import { WINDOW } from './window.service';
import { DOCUMENT } from '@angular/common';
import { GlobalNamespace } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  constructor(
    @Inject(WINDOW) private _window: Window,
    @Inject(DOCUMENT) private _document: Document
  ){ }

  ns = this.namespace;
  key = (GlobalNamespace as any).namespace;

  get document():Document{
    return this._document;
  }

  namespace() {
    const global = GlobalNamespace;

    if (global.hasOwnProperty('namespace')) {
      return this._window[(global as any).namespace];
    }
    return (new Object() as any);
  }

  find(key?: string) {
    if (!key) {
      return this.namespace();
    }

    /* array of keys */
    const ark = key.split(':');

    /* search results to return */
    let doc = this.ns();
    if (ark.length) {
      ark.forEach(el => {
        doc = (doc[el] === undefined) ? '' : doc[el];
      });
    }
    return doc;
  }
}
